/* eslint-disable camelcase */
import { useEffect, useRef } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import qs from 'qs';
import { getURLParams } from '@lib/getUrlParams';
import { replaceQueryWindowHistoryState } from '../../utils/replaceQueryWindowState';
import { clearSessionTransferInFlight, markSessionTransferInFlight } from './SessionTransfer.clientState';
import { SESSION_TRANSFER_TOKEN_PARAM } from './SessionTransfer.utils';

export const useSessionTransfer = () => {
  const { isLoading, loginWithRedirect } = useAuth0();
  const hasStartedTransfer = useRef(false);

  useEffect(() => {
    if (isLoading || hasStartedTransfer.current || typeof window === 'undefined') return;

    const params = getURLParams();
    const sessionTransferToken = params[SESSION_TRANSFER_TOKEN_PARAM];

    if (typeof sessionTransferToken !== 'string' || sessionTransferToken.length === 0) return;

    hasStartedTransfer.current = true;
    markSessionTransferInFlight();

    delete params[SESSION_TRANSFER_TOKEN_PARAM];
    replaceQueryWindowHistoryState(qs.stringify(params, { addQueryPrefix: true }), true);

    loginWithRedirect({
      authorizationParams: { session_transfer_token: sessionTransferToken },
      appState: { returnTo: `${window.location.pathname}${window.location.search}${window.location.hash}` },
    }).catch(() => {
      // The navigation never started, so this document is here to stay. Anything that held its
      // errors back for the redirect has to be allowed to report them again.
      clearSessionTransferInFlight();
    });
  }, [isLoading, loginWithRedirect]);
};
